import type { MealPlanRequest } from '@/types/mealPlan'
import type { BaseSliceState } from '../../types'

export interface MealPlanRequestsState extends BaseSliceState {
  // Holds at most one doc: the subscription streams only the newest request
  // (orderBy createdAt desc, limit 1). An array keeps this slice shaped like its
  // sibling mealPlanResults slice, so the derivations live in the hook.
  mealPlanRequests: MealPlanRequest[]
}

export enum MealPlanRequestsActionTypes {
  SET = 'mealPlanRequests/set',
  SET_ERROR = 'mealPlanRequests/error',
  CLEAR = 'mealPlanRequests/clear'
}

export type MealPlanRequestsAction =
  | { type: MealPlanRequestsActionTypes.SET; payload: MealPlanRequest[] }
  | { type: MealPlanRequestsActionTypes.SET_ERROR; payload: string }
  | { type: MealPlanRequestsActionTypes.CLEAR }
